// extracted by mini-css-extract-plugin
export default {"UpDownButtons":"UpDownButtons_UpDownButtons__F4xx9","up":"UpDownButtons_up__7hMI5","down":"UpDownButtons_down__e08K8"};